import { TanStackDevtools } from "@tanstack/react-devtools";
import { ReactQueryDevtoolsPanel } from "@tanstack/react-query-devtools";
import PurchaserDevPanel from "./PurchaserDevPanel";

const isProduction = import.meta.env["VITE_ENVIRONMENT"] === "production";

// To disable the Tanstack Dev button in the bottom corner + dev panel you can explicitly set this to false in your .env
const isExplicitlyDisabled = import.meta.env["VITE_TANSTACK_DEV_ENABLED"] === "false";

const isDisabled = isProduction || isExplicitlyDisabled;

const Devtools = () => {
    if (isDisabled) return null;

    return (
        <TanStackDevtools
            config={{ hideUntilHover: true, openHotkey: ["CtrlOrMeta", "d"] }}
            plugins={[
                {
                    name: "TanStack Query",
                    render: <ReactQueryDevtoolsPanel />,
                    defaultOpen: false,
                },
                {
                    name: "Purchaser",
                    render: <PurchaserDevPanel />,
                    defaultOpen: false,
                },
            ]}
        />
    );
};

export default Devtools;
